import { Box, Divider, Text, Tooltip } from '@wix/design-system';
import { InfoCircleSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { ThemeAwareIcon } from '../../utils/theme-aware-icon';
export const SectionDivider = _ref => {
  let {
    title,
    tooltipContent,
    backgroundColor = 'D70',
    isTopDivider = false,
    isBottomDivider = false
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%"
  }, isTopDivider && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Box, {
    backgroundColor: backgroundColor,
    gap: "1px",
    padding: "9px 20px",
    verticalAlign: "middle",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    secondary: true
  }, title), tooltipContent && /*#__PURE__*/React.createElement(ThemeAwareIcon, {
    height: "18px",
    marginTop: "4px",
    width: "18px"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltipContent,
    size: "small"
  }, /*#__PURE__*/React.createElement(InfoCircleSmall, null)))), isBottomDivider && /*#__PURE__*/React.createElement(Divider, null));
};
//# sourceMappingURL=section-divider.js.map